module.exports = __webpack_public_path__ + "static/lilizela-aa8b8d02f67d7dbcd2a09d430f5b9993.png";